module.exports = __webpack_public_path__ + "img/ehr.32b6241.svg";